import { useFormContext } from 'react-hook-form';

const useSuggestTextLogic = ({ fieldId, suggestLabel = '' }) => {
  let validSugestLabel = suggestLabel;
  if (typeof validSugestLabel !== 'string') {
    validSugestLabel = '';
  }
  const { getValues } = useFormContext();
  const inputValue = getValues(fieldId);
  let showMatch = false;
  let matchedChars = '';
  let unmatchedChars = '';

  if (inputValue) {
    const inputValueLength = inputValue.length;
    matchedChars = validSugestLabel.slice(0, inputValueLength);
    if (inputValue.toLowerCase() === matchedChars.toLowerCase()) {
      unmatchedChars = validSugestLabel.slice(inputValueLength);
      showMatch = true;
    }
  }

  return { showMatch, matchedChars, unmatchedChars };
};

export default useSuggestTextLogic;
